<template>
  <div class="pages-container">
    <div class="backimg">
      <div class="tophead">
        <p>{{ this.$store.state.title.name.welcome }}</p>
        <h4>Welcome To Smart Community 3.0 !</h4>
      </div>
      <div class="entry">
        <div class="quckly">
          <img src="@/assets/data/ks2.png" alt="" />
          <span>快速入口</span>
        </div>
        <ul class="contentEntry">
          <li
            @click="goshouye()"
            class="waring"
            v-show="hasPerm('sys:jump:echarts')"
          >
            <div class="myImg">
              <img src="@/assets/shouye.svg" alt />
            </div>
            <div>首页</div>
          </li>
          <li @click="goTranfic()">
            <div class="myImg">
              <img
                src="https://s3.pstatp.com/ee/suite/admin/static/imgs/ic-contact-createmployee@1af05835.svg"
                alt
              />
            </div>
            <div>通行记录</div>
          </li>
          <li @click="goPerCheck()" class="waring">
            <div class="myImg">
              <img
                src="https://s3.pstatp.com/ee/suite/admin/static/imgs/ic-appcenter-audit@734eaa12.svg"
                alt
              />
            </div>
            <span class="cfff" v-if="examNumber">{{ examNumber }}</span>
            <div>人员审核</div>
          </li>
          <!-- <li @click="goWarning()" class="waring">
          <div class="myImg">
            <img
              src="https://s3.pstatp.com/ee/suite/admin/static/imgs/ic-appcenter-fullnoticeapp@34563f28.svg"
              alt
            />
          </div>
          <span class="cfff" v-if="infoNumber">{{ infoNumber }}</span>
          <div>推送异常</div>
        </li> -->
          <li
            @click="goecharts()"
            class="waring"
            v-show="hasPerm('sys:jump:echarts')"
          >
            <div class="myImg">
              <img src="@/assets/sjdp.png" alt />
            </div>
            <!-- <span class="cfff" v-if="infoNumber">{{ infoNumber }}</span> -->
            <div>数据大屏</div>
          </li>
        </ul>

        <div class="changVill">
          <span v-if="currentName.length" class="f14"
            >当前小区:{{ currentName }}</span
          >
          <el-button
            type="primary"
            @click="drawer = true"
            style="margin-left: 16px"
          >
            切换小区
          </el-button>
          <el-button
            type="primary"
            @click="lookList('')"
            style="margin-left: 16px"
          >
            清空
          </el-button>
          <el-button
            icon="el-icon-refresh-left"
            @click="goback()"
            circle
          ></el-button>
          <el-drawer
            :visible.sync="drawer"
            :with-header="false"
            class="drawerSty"
            :size="size"
          >
            <h4>小区列表</h4>
            <ul class="outTableSty">
              <li>
                <div class="tableHead">
                  <span>小区名</span><span>小区地址</span>
                  <span
                    class="el-icon-refresh shouzhi"
                    @click="allVillage()"
                  ></span>
                </div>
              </li>
              <li class="tableSty">
                <el-input
                  @clear="clearInp()"
                  placeholder="请输入小区名"
                  v-model="villOne"
                  clearable
                >
                </el-input>
              </li>
              <li
                v-for="(item, index) in villfitList"
                :key="index"
                class="tableSty"
                @click="getDetailsV(item.CID, item.name)"
              >
                <strong>{{ item.name }}</strong>
                <span>{{ item.address }}</span>
              </li>
            </ul>
          </el-drawer>
        </div>
      </div>
    </div>
    <div class="dataTatol">
      <div class="regtotal">
        <div class="perAll">
          <div class="ageEch">
            <Age :key="timer" :CID="CID" />
          </div>
          <div class="sexEch">
            <Sex :key="timer" :CID="CID" />
          </div>
        </div>
        <div class="perType">
          <!-- <span>人员总数</span> -->
          <ul class="peoType" @click="gopeople()">
            <li v-for="(item, index) in perTotal" :key="index" class="typeOne">
              <h4>{{ item.name }}</h4>
              <div class="typePerT">
                <strong>{{ item.value }}</strong>
              </div>
            </li>
          </ul>
          <ul class="houseType">
            <li class="houseTa" @click="qgohousing()">
              <div class="houeAll">
                <img src="@/assets/data/jianzhumianji.png" alt="" />
                <div class="houseData">
                  <strong>{{ villTotal }}</strong>
                  <span>小区总数 </span>
                </div>
              </div>
            </li>
            <li class="housecal" @click="gohouse()">
              <div class="houeAll">
                <img src="@/assets/data/fangyuanshu.png" alt="" />
                <div class="houseData">
                  <strong>{{ houseTotal }}</strong>
                  <span>房屋总数 </span>
                </div>
              </div>
              <div v-for="(item, index) in houTotal" :key="index">
                <strong>{{ item.value }}</strong>
                <span>{{ item.name }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div style="width: 100%;height:100%; display: flex">
        <div class="regstatist">
          <div class="toadyReg">
            <scroller :todayAccount="todayAccount" :CID="CID"></scroller>
            <span class="changDay">
              <span :class="changVul == false ? 'activeText' : ''">周</span>
              <el-switch
                v-model="changVul"
                active-color="#99fcf7"
                inactive-color="#99fcf7"
              >
              </el-switch>
              <span :class="changVul == true ? 'activeText' : ''">日</span>
            </span>
          </div>
          <div class="regEchart">
            <div class="curtrend">
              <Statist
                v-if="changVul == true"
                :key="timer"
                :CID="CID"
              ></Statist>
              <StatistToday
                v-if="changVul == false"
                :key="timer"
                :CID="CID"
              ></StatistToday>
            </div>
            <!-- <div class="contrast">
            <Contrast :key="timer" :CID="CID"></Contrast>
          </div> -->
          </div>
        </div>
        <div class="equiment">
          <div class="eqtop">
            <div class="eqtotal">
              <span
                >设备总数：<span class="text">{{ device_total }}</span></span
              >
            </div>
            <div class="eqnow">
              <span class="nowti"></span>
              <span>在线：</span>
              <span class="text">{{ online_total }}</span>
            </div>
            <div class="eqout">
              <span class="outti"></span>
              <span>离线：</span>
              <span class="text">{{ offline_total }}</span>
            </div>
          </div>
          <div class="eqlist" @click="toeqpage()">
            <vue-seamless-scroll
              :data="eqiment"
              class="seamless-warp"
              :class-option="classOption"
            >
              <ul v-if="eqiment.length" class="item" style="padding:0 10px">
                <li
                  v-for="(item, index) in eqiment"
                  :key="index"
                  class="allconent"
                >
                  <div class="eqconent">
                    <div class="eqxq">
                      {{ item.area_name ? item.area_name : "" }}-{{
                        item.area_name ? item.device_type : ""
                      }}设备
                    </div>
                    <div class="eqstate">离线:{{ item.outday || 0 }}天</div>
                  </div>
                  <div class="eqtip">
                    最后在线时间:{{ $format(Number(item.last_offline_time)) }}
                  </div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
        <!-- <div class="equiment">
          <div class="nowtop">
            <div class="eqtotal">
              <span
                >推送异常总数：<span class="text">{{
                  statetotal || 0
                }}</span></span
              >
            </div>
          </div>
          <div v-if="citylist.length" class="eqlist">
            <vue-seamless-scroll
              :data="citylist"
              class="seamless-warp"
              :class-option="Option"
            >
              <ul class="item">
                <li
                  v-for="(item, index) in citylist"
                  :key="index"
                  class="allconent"
                >
                  <div class="abconent">
                    <div class="abnormal">{{ item.name }}</div>
                  </div>
                  <div class="eqtip">超过24小时未推送数据包至省厅</div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div> -->
        <div></div>
      </div>
    </div>
    <el-dialog
      class="dialog-container"
      title=""
      :visible.sync="isShowNotice"
      :modal-append-to-body="true"
      top="10vh"
    >
      <div class="notice-box col acen">
        <img src="@/assets/notice.png" />
        <div class="f16 mt20 le2 txt">
          <div class="tit1">尊敬的{{ userInfo.name }}用户您好！</div>
          <p class="mt20 c000">
            感谢您对<span class="b">智慧社区综合业务管理平台V3.0</span
            >的使用,运维系统查询到您的账号(<span style="color:red"
              >{{ userInfo.username }}登录账号</span
            >)于<span style="color:red">{{ $format(userInfo.expireTime) }}</span
            >到期，届时该帐号将无法登录智慧社区综合业务管理平台，为不影响您继续使用智慧社区综合业务管理平台，请尽快联系该项目承建单位，感谢您的理解与支持！
          </p>
          <p class="mt10 tit2 b">附补态说明:</p>
          <p>
            您理解并认可，为技术升级、服务体系升级、或因经营策略调整或配合国家重大技术、法规政策等变化，宏恒信息不保证永久的提供某种服务，并有权变更所提供服务的形式、规格或其他方面(如服务的价格和计费模式)，在终止该种服务或进行此种变更前，我们将尽最大努力且提前以网站公告、站内信、邮件或短信等一种或多种方式进行事先通知。服务期届满、服务提前终止(包括双方协商一致提前终止，其他原因导致的提前终止等)或您发生欠费时，除法律法规明确规定、主曾要求或双方另有约定外，我们仅在缓冲期内(15天)继续为您提供服务。缓冲期届满我们将不在为您提供服务和云平台使用权限
          </p>
        </div>
        <el-button
          @click="isShowNotice = false"
          type="primary"
          style="width:135px"
          class="mt30"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import scroller from "./comments/scroller.vue";
import scroll from "./comments/scroll.vue";
import Sex from "./comments/sex";
import Age from "./comments/age";
import Statist from "./comments/statist";
import StatistToday from "./comments/statistToday";
import Contrast from "./comments/contrast";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    scroll,
    scroller,
    Sex,
    Age,
    Statist,
    Contrast,
    StatistToday,
    vueSeamlessScroll
  },
  data() {
    return {
      userInfo: {},
      NoticeData: {},
      isShowNotice: false,
      listData: [],
      villOne: "",
      villfitList: [],
      size: "20%",
      drawer: false,
      loading: false,
      villageList: [],
      changVul: true,
      //当前选中的小区
      currentName: "",
      // 人员统计
      perTotal: [
        { name: "住户", value: "0000" },
        { name: "租户", value: "0000" },
        { name: "服务人员", value: "0000" },
        { name: "从业人员", value: "0000" },
        { name: "访客", value: "0000" },
        { name: "陌生人", value: "0000" }
      ],
      // 房屋统计
      houTotal: [
        { name: "自住", value: "0000" },
        { name: "租户", value: "0000" },
        { name: "闲置", value: "0000" }
      ],
      // 小区总数
      villTotal: "0000",
      houseTotal: "0000",
      price: "500000000",
      todayAccount: "",
      totalAccount: "",
      infoNumber: "",
      dataCount: {},
      // 昨天
      yesterCount: {},
      ydata: [0, 0, 0, 0, 0, 0, 0],
      zdata: [0, 0, 0, 0, 0, 0, 0],
      xdata: ["周天", "周一", "周二", "周三", "周四", "周五", "周六"],
      CID: "",
      timer: "",
      examNumber: "",
      offline_total: "",
      online_total: "",
      device_total: "",
      eqiment: [],
      statetotal: "",
      GidageList: [],
      citylist: []
    };
  },
  computed: {
    classOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    },
    Option() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    }
  },
  watch: {
    villOne(val, oldval) {
      if (val) {
        this.villfitList = this.villageList.filter(item => {
          if (item.name.includes(val)) {
            return item;
          }
        });
      } else {
        this.villfitList = this.villageList;
      }
    }
  },
  created() {
    // 每次进入页面 先看看是否已经选择过小区 如果选择过 就直接加载这个选择的小区数据
    let cid = window.localStorage.getItem("home_CID");
    if (cid) this.CID = cid;
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.getNotice();
    this.getCurrentTime();
  },
  methods: {
    getCurrentTime() {
      let expireTime = this.userInfo.expireTime;
      expireTime = new Date(expireTime).getTime();
      this.$api.warn.getCurrentTime().then(rs => {
        if (rs.code !== 0) return;
        if (expireTime - 15 * 24 * 60 * 60 * 1000 < rs.data) {
          this.isShowNotice = true;
        }
      });
    },
    getNotice() {
      this.$api.login
        .list_notice_nocheck({
          NID: "1b21b443-338e-431b-8052-7918dc599d94"
        })
        .then(rs => {
          if (rs.code === 0 && rs.data && rs.data.length) {
            this.NoticeData = rs.data[0];
          }
        });
    },
    goshouye() {
      this.$router.push({
        path: "/FirstPage"
      });
    },
    goecharts() {
      // window.location.href='http://smartcity.honghengxinxi.com:7005/big/#/renShou'
      window.open("http://smartcity.honghengxinxi.com:7005/big/#/renShou");
    },
    gopeople() {
      this.$router.push({
        path: "/personnel/Population"
      });
    },
    gohousing() {
      this.$router.push({
        path: "/build/NewBuild"
      });
    },
    gohouse() {
      this.$router.push({
        path: "/personnel/OneHousehold"
      });
    },
    clearInp() {
      this.villfitList = this.villageList;
    },
    getDetailsV(val, name) {
      this.CID = val;
      window.localStorage.setItem("home_CID", this.CID);

      if (name) this.currentName = name;
      this.timer = new Date().getTime();
      this.drawer = false;
      this.getInfoNum();
      this.getData();
      this.getBuild();
      this.getBtype();
      this.getExamNum();
    },
    allVillage() {
      this.CID = "";
      this.timer = new Date().getTime();
      this.drawer = false;
      this.getInfoNum();
      this.getData();
      this.getBuild();
      this.getBtype();
      this.getExamNum();
    },
    //刷新页面
    goback() {
      // this.goTranfic();
      this.getDetailsV(this.CID);
    },
    // 小区查询
    // getCommList() {
    //   this.GidageList = this.$store.state.village.villageList;
    // },
    //设备列表
    getEqiment() {
      this.$api.build.sys_device_events_list().then(res => {
        if (res.code == 0) {
          this.offline_total = res.offline_total;
          this.online_total = res.online_total;
          this.device_total = res.device_total;
          this.eqiment = res.data;
          this.eqiment.map(item => {
            if (item.days < 0) {
              item.outday = item.days;
            }
          });
        }
      });
    },
    //异常列表
    getdanger() {
      this.$api.build.warning_list().then(res => {
        if (res.code == 0) {
          this.statetotal = res.count;
          this.citylist = res.not_push_communityArr;
          this.citylist.map(item => {
            this.GidageList.map(val => {
              if (item._id.CID == val.CID) {
                item.name = val.name;
              }
            });
          });
        }
      });
    },
    getCommunityList() {
      this.$api.build.communityName().then(res => {
        if (res.code == 0) {
          this.villageList = res.data;
          this.villfitList = this.villageList;
          this.$store.commit("setvillage", res.data);
          // 判断是否存在 CID
          if (this.CID) {
            // 判断是否存在改CID的小区
            let obj = this.villfitList.find(v => {
              return v.CID == this.CID;
            });
            // 加载该小区数据
            if (obj) this.getDetailsV(this.CID, obj.name);
          }
        }
      });
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background:#3f5c6d2c;";
    },
    toeqpage() {
      this.$router.push({ path: "/resource/AddEquipment" });
    },
    getData() {
      var param = {
        CID: this.CID
      };
      var params = JSON.stringify(param);
      this.loading = true;
      this.$api.dataSc
        .people_type(params)
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.perTotal = res.data;
            // this.perTotal.map(item => {
            //   if (item.name == "其他") {
            //     item.name = "境外人员";
            //   }
            // });
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error("服务器连接失败请重试" + err);
        });
    },
    getBuild() {
      var param = {
        CID: this.CID
      };
      var params = JSON.stringify(param);
      this.loading = true;
      this.$api.dataSc
        .buildings_num(params)
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.villTotal = res.comunities;
            this.houseTotal = res.count;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error("服务器连接失败请重试" + err);
        });
    },
    getBtype() {
      var param = {
        CID: this.CID
      };
      var params = JSON.stringify(param);
      this.loading = true;
      this.$api.dataSc
        .house_type(params)
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.houTotal = res.echart.data;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error("服务器连接失败请重试" + err);
        });
    },

    handleCommand(command) {
      this.$message("click on item " + command);
    },

    // 推送异常
    getInfoNum() {
      let param = {
        CID: this.CID
      };
      this.$api.three.getInforNum(param).then(res => {
        if (res.code == 0) {
          this.loading = false;
          this.infoNumber = res.data.count;
        } else {
          this.$message({
            message: "操作失败, " + res.msg,
            type: "error"
          });
        }
      });
    },
    // 待审核数量
    getExamNum() {
      let that = this;
      let param = {
        auditType: 2,
        auditStatus: "",
        limit: 1,
        page: 1,
        CID: this.CID
      };
      this.$api.personnel.queryList(param).then(res => {
        if (res.code == 0) {
          that.examNumber = res.count;
        } else {
          this.$message({
            message: "操作失败, " + res.Msg,
            type: "error"
          });
        }
      });
    },
    //获取小区的列表选择器
    getcityList() {
      let params = {};
      params = {
        where: {
          CODES: []
        }
      };
      let param = JSON.stringify(params);
      this.loading = true;
      this.$api.three.communityList(params).then(res => {
        if (res.code == 0) {
          this.loading = false;
          this.GidageList = res.data;
        } else {
          this.$message({ message: "操作失败, " + res.msg, type: "error" });
        }
      });
    },
    goHome() {
      // this.$router.push({ path: "/information/Warning" });
      this.$router.push({ path: "/" });
    },
    goTranfic() {
      this.$router.push({ path: "/pass/PersonPass" });
    },
    goPerCheck() {
      this.$router.push({ path: "/pass/Approval" });
    },
    goWarning() {
      // this.$router.push({ path: "/information/Warning" });
      this.$router.push({ path: "/information/Aipower" });
    },
    lookList() {
      window.localStorage.setItem("home_CID", "");
      this.CID = "";
      this.currentName = "";
      this.drawer = false;
      this.timer = new Date().getTime();
      this.getInfoNum();
      this.getData();
      this.getBuild();
      this.getBtype();
      this.getExamNum();
    }
  },
  mounted() {
    this.getcityList();
    this.getInfoNum();
    this.getExamNum();
    this.getData();
    this.getBuild();
    this.getBtype();
    this.getCommunityList();
    this.getEqiment();
  }
};
</script>

<style scoped lang="scss">
.notice-box {
  padding: 15px;
}
//滑动样式
.seamless-warp {
  width: 100%;
  //  height: calc(100% - 16px);
  height: 300px;
  overflow: hidden;
}
.allconent {
  //  border: 1px solid #0f78be;
  // border-radius: 8px;
  background: #1d3357;
  margin-top: 10px;
  padding: 0 10px 2px;
  // width: 100px;
  color: #00fefd;
  // box-shadow: 10px 10px 10px -4px #058596 inset;
}
.sta {
  width: 10px;
  height: 10px;
  background: red;
  // opacity: 1;
  border-radius: 10px;
  display: inline-block;
  margin-right: 5px;
}
.stas {
  width: 10px;
  height: 10px;
  background: #f56c2d;
  // opacity: 1;
  border-radius: 10px;
  display: inline-block;
  margin-right: 5px;
}
.eqstate {
  // background: #fa7d5e;
  // opacity: 0.8;
  border-radius: 4px;
  color: #fff;
}
.eqconent {
  display: flex;
  justify-content: space-between;
  padding: 5px 20px;
  margin-top: 10px;
}
.abconent {
  display: flex;
  justify-content: space-between;
  padding: 0px 20px;
  margin-top: 10px;
}
.eqtip {
  margin-top: 10px;
  margin-left: 20px;
  color: #8dc5df;
  padding: 5px 0;
}
.cfff {
  color: #fff;
}
.f14 {
  font-size: 14px;
}
.pages-container {
  background: rgb(19, 27, 39);
  color: #93ceff;
  // overflow-x: hidden;
  box-sizing: border-box;
  // overflow-y: auto;
  overflow: hidden;
  padding: 0 !important;
  height: 100%;
}
::-webkit-scrollbar {
  width: 10px;
  height: 1px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.backimg {
  background: url("~@/assets/topbg.png") no-repeat;
  background-size: cover;
  background-position: center;
}
.tophead {
  width: 100%;
  height: 150px;
  // background: url("~@/assets/topbg.png") no-repeat;
  // background-size: cover;
  // background-position: center;
  // opacity: 0.9;

  // font-style:italic;
  p {
    padding: 30px 15px 0px;
    background-image: -webkit-linear-gradient(
      left,
      #1a81eb,
      #66ffff 10%,
      #a0e5ff 20%,
      #a0e5ff 30%,
      #ccccff 40%,
      #00ffff 50%,
      #ccccff 60%,
      #a0e5ff 70%,
      #a0e5ff 80%,
      #66ffff 90%,
      #1a81eb 100%
    );
    -webkit-text-fill-color: transparent;
    /* 将字体设置成透明色 */
    -webkit-background-clip: text;
    /* 裁剪背景图，使文字作为裁剪区域向外裁剪 */
    -webkit-background-size: 200% 100%;
    -webkit-animation: masked-animation 4s linear infinite;
    font-size: 28px;
  }

  h4 {
    font-size: 18px;
    padding: 15px;
  }
}

.entry {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  .quckly {
    display: flex;
    align-items: center;
    // font-weight: 500;
    margin: 20px 30px 20px 0;
    font-size: 16px;
    line-height: 32px;
    img {
      height: 50px;
      margin-right: 10px;
    }
  }
}
// 切换小区
.changVill {
  width: auto;
}
.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.project-dropdown {
  //设置高度才能显示出滚动条 !important
  max-height: 300px;
  overflow: auto;
}
.project-dropdown::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #f5f5f5;
}
.project-dropdown::-webkit-scrollbar-track {
  //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
//
.contentEntry {
  width: 75%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  li {
    margin-right: 60px;
    cursor: pointer;
    text-align: center;
    div {
      font-size: 12px;
    }
    img {
      width: 50px;
    }
  }
}
.contentEntry .myImg:hover {
  img {
    transform: translateY(-10px);
  }
}
@keyframes masked-animation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: -100% 0;
  }
}
.waring {
  position: relative;
  span {
    position: absolute;
    top: -10px;
    right: -10px;
    background: #fc6a51;
    border-radius: 20px;
    line-height: 20px;
    text-align: center;
    width: 30px;
    height: 20px;
    font-size: 7px;
  }
}
.equiment {
  background: rgba(49, 112, 230, 0.12);
  height: 450px;
  width: 25%;
  margin-left: 10px;
  box-sizing: border-box;
  position: relative;
}
.eqtop {
  display: flex;
  justify-content: space-around;
  line-height: 120px;
}
.nowtop {
  line-height: 120px;
  margin-left: 20px;
}
.text {
  border: 1px solid #0f78be;
  border-radius: 8px;
  background: rgba(35, 147, 252, 0.2);
  margin-top: 10px;
  padding: 0 10px 2px;
  // width: 100px;
  color: #99fcf7;
  box-shadow: 10px 10px 10px -4px #058596 inset;
}
.nowti {
  width: 10px;
  height: 10px;
  background: #00feb0;
  opacity: 1;
  border-radius: 10px;
  display: inline-block;
}
.outti {
  width: 10px;
  height: 10px;
  background: #fe3400;
  opacity: 1;
  border-radius: 10px;
  display: inline-block;
}
.abnormal {
  // padding: 0 30px;
  margin-top: 10px;
}
// 数据统计
.dataTatol {
  margin: 10px 0;
  padding: 0 10px;
  box-sizing: border-box;
}
.dataTatol::-webkit-scrollbar {
  width: 4px;
}
.regtotal {
  height: 200px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.perAll {
  display: flex;
  justify-content: space-around;
  width: 40%;
  box-sizing: border-box;
  margin-right: 10px;
  background: rgba(49, 112, 230, 0.12);

  .ageEch {
    width: 60%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
    // background: #fff;
  }
  .sexEch {
    width: 40%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
  }
}
.perType {
  width: 60%;
  box-sizing: border-box;
  // overflow: hidden;
  height: 200px;
}
.peoType {
  width: 100%;
  box-sizing: border-box;
  background: rgba(49, 112, 230, 0.12);
  padding: 0 20px;
  box-sizing: border-box;
  height: 55%;
  display: flex;
  justify-content: space-around;
  // color: beige;
  strong {
    display: block;
    color: #99fcf7;
  }

  h4 {
    font-size: 14px;
    text-align: start;
    // text-indent:10px;
  }
  strong {
    margin: 15px 0 5px;
  }
  span {
    font-size: 12px;
  }
}
.typeOne {
  margin: 20px 5px 0;
  flex: 1;
  padding: 0 10px;
}
.typePerT {
  border: 1px solid #0f78be;
  border-radius: 8px;
  background: rgba(35, 147, 252, 0.2);
  margin-top: 10px;
  padding: 0 10px 5px;
  // width: 100px;
  box-shadow: 10px 10px 10px -4px #058596 inset;
}
.houseType {
  background: rgba(49, 112, 230, 0.12);
  margin-top: 5px;
  display: flex;
  justify-content: space-around;
  height: 45%;
  align-items: center;
  strong {
    display: block;
    margin-bottom: 10px;
    color: rgb(153, 252, 247);
  }
}
.houseTa {
  width: 20%;
  display: flex;
  justify-content: space-around;
}
.houeAll {
  margin-right: 5px;
  display: flex;
  justify-content: space-around;
  img {
    height: 50px;
  }
}

.houseData {
  margin-left: 20px;
  text-align: center;

  align-items: center;
}
.housecal {
  display: flex;
  width: 80%;
  justify-content: space-around;
  text-align: center;
}

.regstatist {
  background: rgba(49, 112, 230, 0.12);
  // height: 435px;
  width: 75%;
  // margin-top: 20px;
  box-sizing: border-box;
  position: relative;

  .changDay {
    display: flex;
    height: 30px;
    margin-top: 45px;
    margin-left: 10px;
    align-items: center;
    // line-height: 30px;
    span {
      margin: 0 5px;
      // height: 20px;
    }
  }
}

.toadyReg {
  margin-left: 44%;
  z-index: 9;
  position: absolute;
  display: flex;
  // width: 100% !important;
  // height: 50px;
  // right: 0;
}
.regEchart {
  width: 100%;
  position: absolute;
  bottom: 0;
  height: 400px;
  display: flex;
  justify-content: space-between;
}
.curtrend {
  height: 400px;
  // width: 70%;
  width: 100%;
}
.contrast {
  height: 400px;
  margin-left: 20px;
  width: 30%;
}

// 其他
.perOther {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  height: 30%;
}

.activeText {
  color: #99fcf7;
}

// 侧边栏
.drawerSty {
  h4 {
    text-align: center;
    line-height: 30px;
    color: #84ebdd;
  }
}
/deep/ .el-drawer {
  background: rgba(41, 159, 255, 0.3);
  height: 100%;
  // overflow: hidden;
  overflow-y: auto;
}
.outTableSty {
  padding: 0 10px;
  overflow: hidden;
  box-sizing: border-box;
}
.tableHead {
  // position:absolute;
  // width: 100%;
  line-height: 34px;
  // text-align: center;
  // margin: 0 10px;
  background: rgba(67, 124, 92, 0.3);
  box-shadow: 2px 4px 10px 0px #8dfced inset;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: rgb(203, 221, 255);
  span {
    display: inline-block;
    // width: 35%;
    margin-right: 10px;
    padding-left: 5px;
  }
  overflow: hidden;
  box-sizing: border-box;
  .shouzhi {
    cursor: pointer;
  }
}

.tableSty {
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  background: rgba(94, 168, 253, 0.3);
  margin: 8px 0;
  cursor: pointer;
  box-shadow: 0px -1px 5px 0px #3ab7ff inset;
  strong {
    display: inline-block;
    margin-right: 10px;
    width: 35%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 5px;
  }
  span {
    display: inline-block;
    margin-right: 10px;
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.tit1 {
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #434447;
}
.txt {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #95989d;
  line-height: 24px;
}
.tit2 {
  color: #000;
}
.c000 {
  color: #000;
}
.cddd {
  color: #95989d;
}
</style>



// WEBPACK FOOTER //
// src/views/Intro/Intro.vue